export const propertiesOfFields = {
    sum: "йиғиндиси",
    avg: "ўртачаси",
    min: "паст қийматдагилари",
    max: "юқори қийматдагилари",
    count: "сони",
};
